












import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCTabs',
  data() {
    return {
      activeTab: '',
      registeredTabs: [] as string[],
    };
  },
  mounted() {
    if (this.registeredTabs.length > 0 && !this.activeTab) {
      this.activeTab = this.registeredTabs[0];
    }
  },
  methods: {
    selectTab(tabValue: string) {
      this.activeTab = tabValue;
    },
    registerTab(tabValue: string) {
      if (!this.registeredTabs.includes(tabValue)) {
        this.registeredTabs.push(tabValue);
      }
    },
  },
});
